import { createContext, useContext } from 'react';
import type { EffectTheme } from './effectTheme';

const EffectThemeContext = createContext<EffectTheme | null>(null);

export const EffectThemeProvider = EffectThemeContext.Provider;

// Effects (incl. ParticleCanvas consumers) read theme tokens from here.
// Returns null if used outside an AnimationHost overlay.
export function useEffectTheme(): EffectTheme | null {
  return useContext(EffectThemeContext);
}
